export default (value: any) => {
    if (typeof value === "number") {
        if (value.toString().length === 10) {
            //Projections are chopping off the last 3 digits...
            value = value * 1000
        }
    }
    // Convert to a date object
    const date = new Date(value);
    // Declare the formatter to display in UTC timezone, with full date and time
    const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'UTC',
        timeZoneName: 'short',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hourCycle: 'h23',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
    // Format the date as above
    return formatter.format(date);
}